import React, {useState} from "react";
import {Machine} from "../../../models/machine.models";
import {Step2Validation} from "./move-machine-wizard-steps/Step2Validation";
import {TabData, Wizard} from "../../_shared/wizard/Wizard";
import {Step1Selection} from "./move-machine-wizard-steps/Step1Selection";
import {OrgUnit} from "../../../models/organization";

interface Props {
    organizationId: number,
    goBack: () => void
}

export const MoveMachinesWizard: React.FC<Props> = (props) => {
    const [form, setForm] = useState({
        destinationOrgUnit: {} as OrgUnit,
        machines: [] as Machine[]
    });

    const changeSelectedMachines = (selectedMachines: Map<string, Machine>) => {
        if (selectedMachines) {
            setForm(f => ({
                destinationOrgUnit: {
                    ...f.destinationOrgUnit
                } as OrgUnit,
                machines: (Array.from(selectedMachines, ([id, machine]) => ({
                    ...machine,
                })) as Machine[])
            }));
        }
    }

    const changeDestinationOrgUnit = (orgUnit: OrgUnit) => {
        if (orgUnit) {
            setForm(p => ({...p, destinationOrgUnit: {...orgUnit}}));
        }
    }

    const step1: TabData = {
        labelKey: 'Machine.MoveMachines.Tabs.SelectMachines.Title',
        key: 'move-machine-selection',
        preserveTab: true,
        isDisabled: true,
        childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) =>
            <Step1Selection onClose={props.goBack}
                            onChangeMachineSelection={changeSelectedMachines}
                            organizationId={props.organizationId}
                            index={index}
                            lastIndex={lastIndex}
                            onChangeTab={onChangeTab}
            />
    }

    const step2: TabData = {
        labelKey: 'Machine.MoveMachines.Tabs.Validation.Title',
        key: 'move-machine-validation',
        preserveTab: true,
        isDisabled: true,
        childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) =>
            <Step2Validation form={form}
                             organizationId={props.organizationId}
                             onClose={props.goBack}
                             onChangeDestinationOrgUnit={changeDestinationOrgUnit}
                             index={index}
                             lastIndex={lastIndex}
                             onChangeTab={onChangeTab}
            />
    }
    return Wizard({tabs: [step1, step2]});
};
